module.exports = __webpack_public_path__ + "img/signpost-2.6b732bcb.svg";